import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';
import { ColorPalette } from '../../../../pages/AnalysisPage/Palette/ColorPalette';
import {
  rankIntervals,
  volumeIntervals,
  volumeSegmentNames,
} from '../../../../pages/AnalysisPage/IntervalsAndColorsLogic';
import { adjustTextColor } from '../../../../pages/AnalysisPage/Palette/adjustTextColor';

export interface TopKeywordsCellItemProps {
  keyword: string;
  volume: number;
  rank: number;
  showRanks?: boolean;
  palette: ColorPalette;
}

export const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    box: {
      width: '100%',
      height: '96px',
      border: '2px solid #fff',
      borderRadius: '6px',
      textAlign: 'center',
      position: 'relative',
    },
    keyword: {
      position: 'absolute',
      paddingLeft: '4px',
      paddingRight: '4px',
      top: '14px',
      width: '100%',
      fontSize: '13px',
      fontWeight: theme.typography.fontWeightMedium,
    },
    caption: {
      position: 'absolute',
      width: '100%',
      bottom: '10px',
      left: '50%',
      '-ms-transform': 'translateX(-50%)',
      transform: 'translateX(-50%)',
      fontSize: '11px',
    },
  })
);

export const TopKeywordsCellItem: React.FC<TopKeywordsCellItemProps> = ({
  keyword,
  volume,
  rank,
  showRanks,
  palette,
}) => {
  const rankColors = [...palette.performanceScale];
  const volumeColors = [...palette.performanceScale].slice(0, volumeSegmentNames.length).reverse();

  const valueBgColor = volume
    ? volumeColors[
        volumeIntervals.findIndex(
          (x) => volume >= x.start && (x.end === null ? true : volume <= x.end)
        )
      ]
    : '';
  const rankBgColor = rank
    ? rankColors[
        rankIntervals.findIndex(
          (x) => rank >= x.startRank && (x.endRank === null ? true : rank <= x.endRank)
        )
      ]
    : '';

  let textColor = adjustTextColor(palette, 0.85, 0);

  const classes = useClasses();
  return (
    <div
      className={classes.box}
      style={{ backgroundColor: showRanks ? rankBgColor : valueBgColor, color: textColor }}
    >
      {!(showRanks && !rank) && <Box className={`${classes.keyword} ${textColor}`}>{keyword}</Box>}
      <div
        className={`
        ${classes.caption}
        
      `}
        style={{ color: textColor }}
      >
        {volume != null ? d3.format('.2s')(Math.round(volume)) + ' vol' : ''}
        {showRanks && rank && <span>, #{rank === 101 ? '100+' : rank}</span>}
      </div>
    </div>
  );
};

export default TopKeywordsCellItem;
